const SECTION_DEFINITIONS = [
    { id: 'general', label: 'Home', order: 10 },
    { id: 'operations', label: 'Operations', order: 20 },
    { id: 'commercial', label: 'Commercial', order: 30 },
    { id: 'analytics', label: 'Analytics', order: 40 },
    { id: 'accounting', label: 'Accounting', order: 50 },
    { id: 'administration', label: 'Administration', order: 60 }
];

const NAVIGATION_ITEMS = [
    { id: 'routes', label: 'Gestión de rutas', icon: 'pi pi-map', route: '/route-management', section: 'administration', order: 21, access: ({ canSeeRoutes }) => canSeeRoutes },
    { id: 'coffee-statistics', label: 'Estadísticas de Maquinas de Café', icon: 'pi pi-chart-line', route: '/estadisticas-maquinas-cafe', section: 'analytics', order: 15, access: ({ canSeeCoffeeStatistics }) => canSeeCoffeeStatistics },
    { id: 'purchasing', label: 'Compras', icon: 'pi pi-shopping-cart', route: '/purchasing', section: 'operations', order: 55, access: ({ canSeePurchasing }) => canSeePurchasing },
    { id: 'purchasing-draft', label: 'Compras Draft', icon: 'pi pi-shopping-cart', route: '/purchasing-draft', section: 'operations', order: 56, access: ({ canSeePurchasing }) => canSeePurchasing },
    { id: 'supply-dispatch', label: 'Despacho de Insumos', icon: 'pi pi-box', route: '/despacho-insumos', section: 'operations', order: 50, access: ({ canSeeSupplyDispatch }) => canSeeSupplyDispatch },
    {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'pi pi-home',
        route: '/',
        section: 'general',
        order: 10,
        access: ({ canSeeDashboard }) => canSeeDashboard
    },
    {
        id: 'machines',
        label: 'Machine Management',
        icon: 'pi pi-desktop',
        route: '/machine-list',
        section: 'administration',
        order: 20,
        access: ({ canSeeMachines }) => canSeeMachines
    },
    {
        id: 'technical-service',
        label: 'Technical Service',
        icon: 'pi pi-wrench',
        section: 'operations',
        order: 20,
        children: [
            {
                id: 'machine-inspections',
                label: 'Inspecciones de máquinas',
                icon: 'pi pi-check-square',
                route: '/machine-inspections',
                order: 15,
                access: ({ canSeeMachineInspections }) => canSeeMachineInspections
            },
            {
                id: 'repair-orders',
                label: 'Repair Orders',
                icon: 'pi pi-wrench',
                route: '/repair-orders',
                order: 10,
                access: ({ canSeeRepairOrders }) => canSeeRepairOrders
            },
            {
                id: 'preventive-maintenance',
                label: 'Preventive Maintenance',
                icon: 'pi pi-calendar',
                route: '/preventive-maintenance',
                order: 20,
                access: ({ canSeePreventiveMaintenance }) => canSeePreventiveMaintenance
            },
            {
                id: 'machine-movements',
                label: 'Machine Movements',
                icon: 'pi pi-directions',
                route: '/machine-movements',
                order: 30,
                access: ({ canSeeMachineMovements }) => canSeeMachineMovements
            },
            {
                id: 'parts-inventory',
                label: 'Parts Inventory',
                icon: 'pi pi-box',
                route: '/parts-inventory',
                order: 40,
                access: ({ canSeePartsInventory }) => canSeePartsInventory
            }
        ]
    },
    {
        id: 'complaints',
        label: 'Complain Management',
        icon: 'pi pi-comments',
        section: 'operations',
        order: 30,
        children: [
            {
                id: 'open-complaints',
                label: 'Open Complaints',
                icon: 'pi pi-inbox',
                route: '/open-complaints',
                order: 10,
                access: ({ canSeeOpenComplaints }) => canSeeOpenComplaints
            },
            {
                id: 'refund-queue',
                label: 'Refund Queue',
                icon: 'pi pi-wallet',
                route: '/refund-queue',
                order: 20,
                access: ({ canSeeRefundQueueInComplaints }) => canSeeRefundQueueInComplaints
            },
            {
                id: 'call-history',
                label: 'Call History',
                icon: 'pi pi-phone',
                route: '/call-history',
                order: 40,
                access: ({ canSeeCallHistory }) => canSeeCallHistory
            },
            {
                id: 'close-complaints',
                label: 'Close Complaints',
                icon: 'pi pi-check-circle',
                route: '/close-complaints',
                order: 30,
                access: ({ canSeeCloseComplaints }) => canSeeCloseComplaints
            }
        ]
    },
    {
        id: 'refund-queue-finance',
        label: 'Refund Queue',
        icon: 'pi pi-wallet',
        route: '/refund-queue',
        section: 'accounting',
        order: 10,
        access: ({ canSeeStandaloneRefundQueue }) => canSeeStandaloneRefundQueue
    },
    {
        id: 'sales',
        label: 'Sales',
        icon: 'pi pi-briefcase',
        route: '/ventas',
        section: 'commercial',
        order: 10,
        access: ({ canAccessVentas }) => canAccessVentas
    },
    {
        id: 'users',
        label: 'User Management',
        icon: 'pi pi-users',
        route: '/user-list',
        section: 'administration',
        order: 30,
        access: ({ canSeeUsers }) => canSeeUsers
    },
    {
        id: 'teams',
        label: 'Teams Management',
        icon: 'pi pi-sitemap',
        route: '/team-list',
        section: 'administration',
        order: 40,
        access: ({ canSeeTeams }) => canSeeTeams
    },
    {
        id: 'operations-people',
        label: 'Operations & People',
        icon: 'pi pi-id-card',
        route: '/hr-module',
        section: 'administration',
        order: 10,
        access: ({ canSeeOperationsAndPeople }) => canSeeOperationsAndPeople
    },
    {
        id: 'reports',
        label: 'Analytics & Reports',
        icon: 'pi pi-chart-bar',
        route: '/reports',
        exact: true,
        section: 'analytics',
        order: 10,
        access: ({ canSeeReports }) => canSeeReports
    },
    {
        id: 'customer-reports',
        label: 'Customer Reports',
        icon: 'pi pi-chart-line',
        route: '/customer-reports',
        section: 'commercial',
        order: 20,
        access: ({ canAccessCustomerReports }) => canAccessCustomerReports
    },
    {
        id: 'okr',
        label: 'OKR',
        icon: 'pi pi-flag',
        route: '/okr',
        section: 'analytics',
        order: 30,
        access: ({ canSeeOkr }) => canSeeOkr
    },
    {
        id: 'operator-dashboard',
        label: 'Operator Dashboard',
        icon: 'pi pi-chart-pie',
        route: '/operator-dashboard',
        section: 'analytics',
        order: 40,
        access: ({ canAccessOperatorDashboard, canSeeCoffeeRegistration }) => canAccessOperatorDashboard || canSeeCoffeeRegistration
    },
    {
        id: 'machine-platforms',
        label: 'Machine Platforms',
        icon: 'pi pi-server',
        section: 'operations',
        order: 40,
        children: [
            {
                id: 'parlevel-overview',
                label: 'Overview',
                icon: 'pi pi-chart-line',
                route: '/parlevel',
                exact: true,
                order: 10,
                access: ({ canAccessParlevelOverview }) => canAccessParlevelOverview
            },
            {
                id: 'parlevel-route-planning',
                label: 'Route Planning',
                icon: 'pi pi-map',
                route: '/parlevel/routes',
                order: 15,
                access: ({ canAccessParlevelRoutePlanning }) => canAccessParlevelRoutePlanning
            },
            {
                id: 'parlevel-coin-tubes',
                label: 'Coin Tubes',
                icon: 'pi pi-dollar',
                route: '/parlevel/change-levels',
                order: 20,
                access: ({ canAccessParlevelChangeLevels }) => canAccessParlevelChangeLevels
            },
            {
                id: 'parlevel-data-sync',
                label: 'Data & Sync',
                icon: 'pi pi-database',
                route: '/parlevel/data',
                order: 30,
                access: ({ canAccessParlevelData }) => canAccessParlevelData
            },
            {
                id: 'jetinno',
                label: 'Jetinno',
                icon: 'pi pi-bolt',
                route: '/jetinno',
                order: 40,
                access: ({ canAccessJetinno }) => canAccessJetinno
            },
            {
                id: 'products',
                label: 'Productos',
                icon: 'pi pi-tags',
                route: '/products',
                order: 49,
                access: ({ canAccessProducts }) => canAccessProducts
            },
            {
                id: 'tcn',
                label: 'TCN',
                icon: 'pi pi-box',
                route: '/tcn',
                order: 50,
                access: ({ canAccessTcn }) => canAccessTcn
            }
        ]
    },
    {
        id: 'quickbooks',
        label: 'QuickBooks',
        icon: 'pi pi-wallet',
        route: '/quickbooks',
        section: 'accounting',
        order: 20,
        access: ({ canSeeQuickBooks }) => canSeeQuickBooks
    },
    {
        id: 'revenue-reconciliation',
        label: 'Revenue Reconciliation',
        icon: 'pi pi-money-bill',
        route: '/revenue-reconciliation',
        section: 'accounting',
        order: 10,
        access: ({ canSeeRevenueReconciliation }) => canSeeRevenueReconciliation
    },
    {
        id: 'questions',
        label: 'Question Management',
        icon: 'pi pi-question-circle',
        route: '/managequestions',
        section: 'administration',
        order: 50,
        access: ({ canSeeQuestions }) => canSeeQuestions
    }
];

const isItemVisible = (item, access) => (typeof item.access === 'function' ? item.access(access) : true);

const getItemPlacement = (item, access) => {
    if (access.isOperator && item.id === 'operator-dashboard') {
        return { section: 'analytics', order: 0 };
    }

    return { section: item.section, order: item.order };
};

const getSectionOrder = (section, access) => {
    if (access.isOperator && section.id === 'analytics') return 0;
    if (access.isOperator && section.id === 'operations') return 10;
    return section.order;
};

const getItemLabel = (item, access) =>
    access.isOperator && item.id === 'operator-dashboard' ? 'Dashboard' : item.label;

const localizeItem = (item, translate, access) => {
    if (item.children) {
        const visibleChildren = item.children
            .filter((child) => isItemVisible(child, access))
            .sort((first, second) => first.order - second.order)
            .map((child) => ({ ...child, label: translate(child.label) }));

        if (!visibleChildren.length) return null;

        return { ...item, label: translate(getItemLabel(item, access)), children: visibleChildren };
    }

    if (!isItemVisible(item, access)) return null;

    return { ...item, ...(item.id === 'purchasing' && access.purchasingAlertCount > 0 ? { badge: access.purchasingAlertCount } : {}), label: translate(getItemLabel(item, access)) };
};

export const buildSyncroNavigation = (access, translate = (value) => value) =>
    SECTION_DEFINITIONS.map((section) => {
        const items = NAVIGATION_ITEMS.filter((item) => getItemPlacement(item, access).section === section.id)
            .sort((first, second) => getItemPlacement(first, access).order - getItemPlacement(second, access).order)
            .map((item) => localizeItem(item, translate, access))
            .filter(Boolean);

        return { ...section, label: translate(section.label), items };
    })
        .filter((section) => section.items.length > 0)
        .sort((first, second) => getSectionOrder(first, access) - getSectionOrder(second, access));

export { NAVIGATION_ITEMS, SECTION_DEFINITIONS };

// Use the sidebar catalog for ticket classification, including nested screens.
export const getSyncroModuleOptions = (translate = (value) => value) => {
    const routes = new Set();
    return NAVIGATION_ITEMS.flatMap((item) =>
        item.children
            ? item.children.map((child) => ({ label: `${translate(item.label)} / ${translate(child.label)}`, value: child.route }))
            : [{ label: translate(item.label), value: item.route }]
    ).filter((option) => {
        if (!option.value || routes.has(option.value)) return false;
        routes.add(option.value);
        return true;
    });
};
